<template>
<div class="flex justify-end mb-2">
  <div class="inline-block text-xxs">
      <button class="verbose-button px-2 py-1" @click="toggleBodyClass('addClass', 'verbose-inbox')">Show All Notifications</button>
      <button class="hideverbose-button px-2 py-1" @click="toggleBodyClass('removeClass', 'verbose-inbox')">Show Important Notifications</button>
  </div>
</div>
</template>

<script>

    export default {

        methods: {
          toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
              el.classList.add(className);
            } else {
              el.classList.remove(className);
            }
          },
        },

    }
</script>